<template>
    <div>
      <ApportionmentList/>
    </div>
</template>

<script>
import ApportionmentList from '../../components/apportionment/apportionment/apportionmentList.vue';

export default {
  name: 'apportionment',
  data: () => ({

  }),
  components: {
    ApportionmentList,
  },
};
</script>
